'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _uiTranslations = require('@wh/ui-translations');

var _selectors = require('../selectors');

var _checkboxes = require('./checkboxes');

var _checkboxes2 = _interopRequireDefault(_checkboxes);

var _actions = require('../login-component/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = (0, _reselect.createStructuredSelector)({
    showKeepMeLoggedIn: _selectors.getKeepMeLoggedIn
});

var mapDispatchToProps = {
    trackingEvent: _actions.trackingEvent
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _uiTranslations.withTranslator)(_checkboxes2.default));
//# sourceMappingURL=Container.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/checkboxes/Container.js
// module id = 475
// module chunks = 0